export default __webpack_public_path__ + "fd3d7207f0542890a27a636d9209e2f9.svg";